<script lang="ts">
  import { onDestroy, onMount, type Snippet } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import { mdiClose, mdiCalendarOutline } from "@mdi/js"

  type OverlayHostProps = {
    onremoveOverlay?: () => void
    onshowOverlay?: () => void
    setActionButtonSnippet?: (snippet: Snippet | null) => void
  }

  let {
    onshowcalendar,
    onremoveOverlay = null,
    onshowOverlay = null,
    setActionButtonSnippet = null,
  }: {
    onshowcalendar: () => void
  } & OverlayHostProps = $props()

  const stayWithRecommendations = () => {
    onremoveOverlay?.()
  }

  const showCalendar = () => {
    onremoveOverlay?.()
    onshowcalendar()
  }

  onMount(() => {
    onshowOverlay?.()
    setActionButtonSnippet?.(actionButtons)
  })

  onDestroy(() => {
    setActionButtonSnippet?.(null)
  })
</script>

<div class="calendar-notice">
  <p>
    Die vorgeschlagenen Termine passen besonders gut in die bestehende Tour und helfen dem
    Schornsteinfegerbetrieb, zusätzliche Fahrten und Leerlauf zu vermeiden. Wenn es für Sie möglich
    ist, wählen Sie bitte einen dieser Termine. Sie können sich dennoch alle verfügbaren Termine
    anzeigen lassen.
  </p>
  <div class="calendar-notice-actions">
    <CTA
      type="tertiaryButton"
      content="Alle Termine anzeigen"
      darkMode={true}
      onClick={showCalendar}
      icon={mdiCalendarOutline}
      fullWidth={true}
    />
    <CTA
      type="primaryButton"
      content="Bei Vorschlägen bleiben"
      darkMode={false}
      icon={mdiClose}
      onClick={stayWithRecommendations}
      fullWidth={true}
    />
  </div>
</div>

{#snippet actionButtons()}
  <div></div>
{/snippet}

<style>
  .calendar-notice {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1rem;
  }

  .calendar-notice p {
    margin: 0;
    color: var(--bg-200);
    line-height: 1.5;
  }

  .calendar-notice-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0.75rem;
    width: 100%;
  }

  @media (max-width: 560px) {
    .calendar-notice-actions {
      grid-template-columns: minmax(0, 1fr);
    }
  }
</style>
